import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import SecondaryActionBar from '../../../ActionBar/SecondaryActionBar';

export interface Props {
  deviation: PapiDeviation;
  withSecondaryActionBar: boolean;
  className?: string;
}

export const SecondaryActionBarWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  deviation,
  withSecondaryActionBar,
  className,
}) => {
  return withSecondaryActionBar ? (
    <SecondaryActionBar deviation={deviation} wrapperClassName={className}>
      {children}
    </SecondaryActionBar>
  ) : (
    <>{children}</>
  );
};
SecondaryActionBarWrapper.displayName = 'SecondaryActionBarWrapper';

export default SecondaryActionBarWrapper;
